import { useEffect } from "react";

const useEventListener = (eventName, handler) => {
  useEffect(() => {
    document.addEventListener(eventName, handler);
    return () => {
      document.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
};

export default useEventListener;
